// AUTO-GENERATED by scripts/generate-version.js — do not edit by hand.
// Sourced from package.json (bumped automatically by the version-bump workflow).
export const APP_VERSION = "0.4.68";
